import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ISummeryResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ISummeryResponse>,
  IPathBaseParam,
  object
>("stores.customers.salesInvoices.summery");

export const summery = {
  ...getApis,
};
